import Class from './c-content-char-bars';
import './c-content-char-bars@.vue';

export default Class;